import React from "react";
import { useInView } from "react-intersection-observer";
import { StaticImage } from "gatsby-plugin-image";
import { AnchorLink } from "gatsby-plugin-anchor-links";

// Component
import CardsComponent from "./Cards";

// CSS
import * as styles from "./BodyMetabolism.module.css";

const BodyMetabolismComponent = props => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <>
      <div
        ref={ref}
        className={`container-fluid scroll_animate ${inView && "inview"} ${
          styles.diabConsLp__bdyMetablsm__cont
        }`}
      >
        <div className="row">
          <div className="col-12">
            <div className={styles.diabConsLp__bdyMetablsm__hdng}>
              <h3>{props.heading}</h3>
              <p>{props.subHeading}</p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className={styles.diabConsLp__bdyMetablsm__bannerImgDesk}>
              <StaticImage
                src="../../../../images/LandingPage/diabetes-conslt-body-banner-desktop.png"
                alt="banner_image"
                className="img-fluid"
                placeholder="blurred"
                quality={90}
              />
            </div>
            <div className={styles.diabConsLp__bdyMetablsm__bannerImgMob}>
              <StaticImage
                src="../../../../images/LandingPage/diabetes-conslt-body-banner-mob.png"
                alt="banner_image"
                className="img-fluid"
                placeholder="blurred"
                quality={90}
              />
            </div>
          </div>
        </div>
        <div>
          <CardsComponent cardDetails={props.cardDetails} />
        </div>
        <div className="row">
          <div className="col-12">
            <div
              className={`text-center ${styles.diabConsLp__bdyMetablsm__cta}`}
            >
              <AnchorLink
                to={props.ctaRedirectionUrl}
                onAnchorLinkClick={() =>
                  props.handleMixpanelCTA(
                    props.ctaText,
                    props.mixpanelCtaLocation
                  )
                }
              >
                <button>{props.ctaText}</button>
              </AnchorLink>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BodyMetabolismComponent;
